import { Dimension, Product } from '@inter-ikea-storageone/range';
import { ProductType } from '@inter-ikea-storageone/range';

export const getMatchingSections = (
  previousSection: Product | null,
  products: Product[],
  matchBy: Dimension
) => {
  if (!previousSection) return [];
  return products.filter(product => {
    return (
      product.type === ProductType.BROR_SECTION &&
      product.communicatedDimensions.width === previousSection?.communicatedDimensions.width &&
      product.communicatedDimensions[matchBy] ===
        previousSection?.communicatedDimensions[matchBy] &&
      product.design === previousSection?.design
    );
  });
};

export const getMatchingWidthsOfSections = (
  previousSection: Product | null,
  products: Product[]
) => {
  if (!previousSection) return [];
  return products.filter(product => {
    return (
      product.type === ProductType.BROR_SECTION &&
      product.communicatedDimensions.depth === previousSection?.communicatedDimensions.depth &&
      product.communicatedDimensions.height === previousSection?.communicatedDimensions.height &&
      product.design === previousSection?.design
    );
  });
};
